import { AsyncState, Updater, loadingAsyncState } from 'widgets-for-react'
import {
  loadCss,
  LoadCssReponse,
  loadScript,
  LoadScriptReponse
} from '../../utils/scripts'
import { disableJqueryFocus } from './jqueryUtils'

export type JqueryState = {
  jquery: AsyncState<LoadScriptReponse<'jq'>>
  jqueryValidate: AsyncState<LoadScriptReponse<'jqa'>>
  jqueryUi: AsyncState<LoadScriptReponse<'jqui'>>
  jqueryUiCss: AsyncState<LoadCssReponse<'jquicss'>>
}

export const initialJqueryState = (): JqueryState => ({
  jquery: loadingAsyncState(async () => ({
    kind: 'result',
    value: await loadScript(
      'https://static.mailplus.nl/jq/jquery-1.6.1.min.js',
      'jq'
    ),
    status: 200
  })),
  jqueryValidate: loadingAsyncState(async () => ({
    kind: 'result',
    value: await loadScript(
      'https://static.mailplus.nl/jq/jquery.validate.min.js',
      'jqa'
    ),
    status: 200
  })),
  jqueryUi: loadingAsyncState(async () => ({
    kind: 'result',
    value: await loadScript(
      'https://static.mailplus.nl/jq/jquery-ui-1.8.18.custom.min.js',
      'jqui'
    ),
    status: 200
  })),
  jqueryUiCss: loadingAsyncState(async () => ({
    kind: 'result',
    value: await loadCss(
      'https://static.mailplus.nl/jq/css/ui-lightness/jquery-ui-1.8.18.custom.css',
      'jquicss'
    ),
    status: 200
  }))
})

export const jqueryStateUpdaters = {
  updateJquery: (updater: Updater<AsyncState<LoadScriptReponse<'jq'>>>) => (
    state: JqueryState
  ): JqueryState => {
    const newState = updater(state.jquery)
    if (newState.kind === 'loaded' && state.jquery.kind !== 'loaded') {
      disableJqueryFocus()
    }
    return {
      ...state,
      jquery: updater(state.jquery)
    }
  },
  updateJqueryValidate: (
    updater: Updater<AsyncState<LoadScriptReponse<'jqa'>>>
  ) => (state: JqueryState): JqueryState => ({
    ...state,
    jqueryValidate: updater(state.jqueryValidate)
  }),
  updateJqueryUi: (updater: Updater<AsyncState<LoadScriptReponse<'jqui'>>>) => (
    state: JqueryState
  ): JqueryState => ({
    ...state,
    jqueryUi: updater(state.jqueryUi)
  }),
  updateJqueryUiCss: (
    updater: Updater<AsyncState<LoadCssReponse<'jquicss'>>>
  ) => (state: JqueryState): JqueryState => ({
    ...state,
    jqueryUiCss: updater(state.jqueryUiCss)
  })
}
